import React from "react";

import { faEnvelope } from "@fortawesome/pro-solid-svg-icons/faEnvelope";
import { useIntl } from "react-intl";

import { Activity } from "@mapmycustomers/shared/types/entity";

import Section from "@app/component/activity/ActivityAnnotation/Section";
import SentEmailBody from "@app/component/email/SentEmailBody";
import SentEmailRecipients from "@app/component/email/SentEmailRecipients";
import SentEmailSubject from "@app/component/email/SentEmailSubject";

interface EmailSectionProps {
  activity: Activity;
  allowSendViaEmailClient?: boolean;
  allowSendViaMmcEmail?: boolean;
}

const EmailSection = ({
  activity,
  allowSendViaEmailClient,
  allowSendViaMmcEmail,
}: EmailSectionProps) => {
  const intl = useIntl();

  if (!activity.emailLog) {
    return null;
  }

  return (
    <Section
      icon={faEnvelope}
      title={intl.formatMessage({
        id: "component.activityAnnotation.emailSection.title",
        defaultMessage: "Email",
        description: "Email section title",
      })}
    >
      <SentEmailRecipients
        activity={activity}
        allowSendViaEmailClient={allowSendViaEmailClient}
        allowSendViaMmcEmail={allowSendViaMmcEmail}
      />
      <SentEmailSubject subject={activity.emailLog.subject} />
      <SentEmailBody body={activity.emailLog.body} />
    </Section>
  );
};

export default EmailSection;
